<template>
  <div>
    <div class="footer" id="contact">
      <div class="row mb-5 footer-content1">
        <div class="col-md-3 footer-right">
          <div class="footer-logo">
            <div class="logo-icon"></div>
            <span class="logo-text">GRANDILO</span>
          </div>
          <br/>
          <div class="text">
            <p>
              Plot 8 The Providence St, Lekki Phase 1, Lekki 106104, Lagos
            </p>
          </div>
        </div>
        <div class="col-md-2 footer-content">
          <h2>About Us</h2>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="#services">Our Services</a></li>
            <li><a href="/career">Careers</a></li>
            <li><a href="/blog-post">Blogs</a></li>
            <li><a href="/contactus">Contact Us</a></li>
          </ul>
        </div>
        <div class="col-md-2 footer-content">
          <h2>OUR PRODUCTS</h2>
          <ul>
            <li>
              <a href="https://www.getposa.com" target="_blank">Posa - Flagship Platform</a>
            </li>
            <li>
              <a href="https://www.getposa.com" target="_blank">Sales Recording</a>
            </li>
            <li>
              <a href="https://www.getposa.com" target="_blank">Inventory Management</a>
            </li>
            <li>
              <a href="https://www.getposa.com" target="_blank">Online Store Setup</a>
            </li>
            <li>
              <a href="https://www.getposa.com" target="_blank">Fraud Prevention</a>
            </li>
          </ul>
        </div>
        <div class="col-md-5 footer-content">
          <h2>CONTACT US</h2>
          <ul class="ul">
            <li>
              <i class="fa fa-envelope" style="color: white"></i>
              info@grandilo.com
            </li>
            <li>
              <i class="fa fa-phone" style="color: white"></i>
              <a href="tel: +234 8111875720"> +234 8111875720</a>
            </li>
            <li>
              <i class="fa fa-whatsapp" style="color: #218d80"></i> +234
              8111875720
            </li>
            <li class="last">
              <a href="https://twitter.com/grandilong" target="_blank"> <img src="../assets/icons/download2.svg"/></a>
              <a href="https://ng.linkedin.com/company/grandilo" target="_blank"> <img
                  src="../assets/icons/download3.svg"/></a>
              <a href="https://web.facebook.com/grandilo" target="_blank"> <img
                  src="../assets/icons/download1.svg"/></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p class="p-header">
          &copy; {{ (() => new Date().getFullYear())() }} Grandilo Technology LTD.
        </p>
      </div>
    </div>
    <button class="backtotop" v-show="top" @click.prevent="BacktoTop('#top')">
      <i className="fa fa-arrow-up text-white"></i>
    </button>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";

export default defineComponent({
  /* eslint-disable */
  name: "Footer",
  setup() {
    const top = ref(false);
    onMounted(() => {
      window.addEventListener("scroll", handleScrolltop);
    });

    function BacktoTop(content: string) {
      // Scroll to a certain element
      document.querySelector(content)?.scrollIntoView({
        behavior: "smooth",
      });
    }

    function handleScrolltop() {
      if (window.scrollY > 100) {
        top.value = true;
      } else {
        top.value = false;
      }
    }

    return {
      top,
      BacktoTop,
    };
  },
});
</script>

<style scoped>
.backtotop {
  background-color: #009688;
  color: white;
  width: 40px;
  outline: none;
  border: none;
  cursor: pointer;
  margin-top: -100px;
  z-index: 4;
  padding: 5px;
  border-radius: 50px;
  box-shadow: 2px 2px 4px rgba(88, 133, 73, 0.986);
  position: fixed;
  bottom: 20px;
  right: 20px;
  height: 50px;
  width: 50px;
  transition: 0.5s;
}

.backtotop:hover {
  margin-bottom: 5px;
}

.footer {
  background-color: black;
  position: relative;
  height: 50%;
  width: 100%;
  padding: 30px;
  padding-top: 70px;
}

.footer-content1 {
  width: 90%;
  margin: auto;
}

.footer-content h2 {
  color: #ffff;
  font-family: sans-serif;
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 600;
  text-align: left;
}

.footer-content p {
  text-align: left;
  width: 80%;
  font-size: 14px;
  color: #ffff;
}

.footer-content ul {
  list-style: none;
  text-align: left;
  margin-left: -40px;
}

.footer-content .ul {
  list-style: none;
  text-align: left;
  margin-left: -40px;
}

.footer-content ul li {
  color: #ffff;
  font-size: 14px;
}

.last {
  margin-left: 20px;
  padding-top: 10px;
}

.last img {
  padding: 4px;
}

.footer-content a {
  color: #ffff;
  padding: 0;
  text-decoration: none;
}

.apple img:hover {
  border: 2px solid #218d80;
  border-radius: 4px;
}

.footer-bottom {
  background-color: black;
  text-align: center;
  color: #ffff;
  padding: 10px;
}

.footer-bottom p {
  font-size: 14px;
  color: #fff;
}

.footer-right {
  text-align: left;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.logo-icon {
  width: 30px;
  height: 30px;
  background: #00C896;
  border-radius: 4px;
  position: relative;
}

.logo-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  background: #ffffff;
  border-radius: 2px;
}

.logo-text {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
}

.footer-right .text p {
  color: #ffff;
  width: 70%;
  font-size: 13px;
}

.terms1 {
  display: none;
}

.bottom-p {
  width: 40%;
  margin: auto;
}

@media screen and (max-width: 807px) {
  .bottom-p {
    width: 80%;
    margin: auto;
  }

  .footer {
    padding-left: 0px;
    padding-right: 0px;
  }

  .footer-content .ul {
    list-style: none;
    text-align: left;
    margin-left: -40px;
  }

  .footer-content ul {
    margin-left: -40px;
  }

  .footer-content .ul .last {
    margin-left: -2px;
  }

  .footer-bottom .p-header {
    color: #218d80;
    margin-top: -40px;
    padding-bottom: 30px;
  }
}
</style>
